import React, { useEffect, useState } from 'react';
import RibbonActions from '../components/RibbonActions';
import {
  getEmpleados, API_BASE,
  rhContratos, rhCrearContrato, rhBorrarContrato,
  rhDocumentos, rhSubirDocumento, rhBorrarDocumento,
  rhVacaciones, rhSaldoVacaciones, rhCrearVacacion, rhResolverVacacion, rhBorrarVacacion,
  rhAusencias, rhCrearAusencia, rhResolverAusencia, rhBorrarAusencia,
  rhEvaluaciones, rhCrearEvaluacion, rhBorrarEvaluacion,
} from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const dias = (a, b) => (a && b) ? Math.round((new Date(b) - new Date(a)) / 86400000) + 1 : 0;
const EST = { aprobado: { c: '#10b981', bg: '#022c22' }, pendiente: { c: '#fbbf24', bg: '#422006' }, rechazado: { c: '#fca5a5', bg: '#450a0a' } };
const Badge = ({ e }) => { const x = EST[e] || EST.pendiente; return <span style={{ background: x.bg, color: x.c, borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>{e}</span>; };
const TABS = [['contratos', 'Contratos'], ['vacaciones', 'Vacaciones'], ['ausencias', 'Ausencias'], ['documentos', 'Documentos'], ['evaluaciones', 'Evaluaciones']];

export default function RecursosHumanos() {
  const [emps, setEmps] = useState([]);
  const [empId, setEmpId] = useState('');
  const [tab, setTab] = useState('contratos');

  useEffect(() => { getEmpleados().then(r => { setEmps(r.data); if (r.data[0]) setEmpId(r.data[0].id); }).catch(() => {}); }, []);
  const emp = emps.find(e => e.id === empId);

  const descargarCert = async (salario) => {
    try {
      const resp = await fetch(`${API_BASE}/api/rh/empleados/${empId}/certificado?salario=${salario}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('erp_token')}`, ...(localStorage.getItem('erp_acting_tenant') ? { 'x-acting-tenant': localStorage.getItem('erp_acting_tenant') } : {}) },
      });
      if (!resp.ok) throw new Error();
      const url = URL.createObjectURL(await resp.blob());
      window.open(url, '_blank'); setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch { alert('No se pudo generar el certificado'); }
  };

  return (
    <div>
      <div style={s.header}>
        <div><h1 style={s.h1}>Recursos Humanos</h1><p style={s.sub}>Contratos, vacaciones, ausencias, documentos y evaluaciones</p></div>
        <RibbonActions>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <select style={s.sel} value={empId} onChange={e => setEmpId(e.target.value)}>
              <option value="">— Empleado —</option>
              {emps.map(e => <option key={e.id} value={e.id}>{e.nombres} {e.apellidos}</option>)}
            </select>
            {empId && <>
              <button style={s.btnSec} onClick={() => descargarCert(true)}>📄 Certificado</button>
              <button style={s.btnSec} onClick={() => descargarCert(false)}>📄 Sin salario</button>
            </>}
          </div>
        </RibbonActions>
      </div>

      {!empId ? <p style={{ color: '#64748b' }}>Selecciona un empleado. (Los empleados se crean en Nómina → Empleados.)</p> : (
        <>
          {emp && <div style={s.ficha}>
            <div><b style={{ color: '#f1f5f9' }}>{emp.nombres} {emp.apellidos}</b> · {emp.cargo || '—'}</div>
            <div style={{ color: '#64748b', fontSize: 12 }}>{emp.tipo_documento} {emp.numero_documento} · Ingreso {fdate(emp.fecha_ingreso)} · {emp.tipo_contrato || '—'} · {fmt(emp.salario_base)}</div>
          </div>}
          <div style={s.tabs}>{TABS.map(([k, l]) => <button key={k} style={{ ...s.tab, ...(tab === k ? s.tabOn : {}) }} onClick={() => setTab(k)}>{l}</button>)}</div>
          {tab === 'contratos' && <Contratos empId={empId} />}
          {tab === 'vacaciones' && <Vacaciones empId={empId} />}
          {tab === 'ausencias' && <Ausencias empId={empId} />}
          {tab === 'documentos' && <Documentos empId={empId} />}
          {tab === 'evaluaciones' && <Evaluaciones empId={empId} />}
        </>
      )}
    </div>
  );
}

// ── Contratos ──
function Contratos({ empId }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState(null);
  const load = () => rhContratos(empId).then(r => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [empId]);
  const guardar = async () => { try { await rhCrearContrato(empId, f); setF(null); load(); } catch (e) { alert(e.response?.data?.error || 'Error'); } };
  return (
    <Card>
      <BtnNuevo onClick={() => setF({ tipo: 'indefinido', cargo: '', salario: '', fecha_inicio: '', fecha_fin: '', estado: 'vigente', notas: '' })} label="+ Contrato" />
      {f && <FormBox onCancel={() => setF(null)} onSave={guardar}>
        <Sel label="Tipo" value={f.tipo} onChange={v => setF({ ...f, tipo: v })} opts={['indefinido', 'fijo', 'obra o labor', 'aprendizaje', 'prestación de servicios']} />
        <Inp label="Cargo" value={f.cargo} onChange={v => setF({ ...f, cargo: v })} />
        <Inp label="Salario" type="number" value={f.salario} onChange={v => setF({ ...f, salario: v })} />
        <Inp label="Inicio" type="date" value={f.fecha_inicio} onChange={v => setF({ ...f, fecha_inicio: v })} />
        <Inp label="Fin (opcional)" type="date" value={f.fecha_fin} onChange={v => setF({ ...f, fecha_fin: v })} />
        <Sel label="Estado" value={f.estado} onChange={v => setF({ ...f, estado: v })} opts={['vigente', 'terminado', 'suspendido']} />
      </FormBox>}
      <Tabla cols={['Tipo', 'Cargo', 'Salario', 'Inicio', 'Fin', 'Estado', '']} rows={rows} render={c => [
        c.tipo, c.cargo, fmt(c.salario), fdate(c.fecha_inicio), fdate(c.fecha_fin), c.estado,
        <Del onClick={async () => { if (window.confirm('¿Eliminar contrato?')) { await rhBorrarContrato(c.id); load(); } }} />]} />
    </Card>
  );
}

// ── Vacaciones ──
function Vacaciones({ empId }) {
  const [rows, setRows] = useState([]); const [saldo, setSaldo] = useState(null); const [f, setF] = useState(null);
  const load = () => { rhVacaciones(empId).then(r => setRows(r.data)).catch(() => {}); rhSaldoVacaciones(empId).then(r => setSaldo(r.data)).catch(() => {}); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [empId]);
  const guardar = async () => { try { await rhCrearVacacion(empId, { ...f, dias: dias(f.fecha_inicio, f.fecha_fin) }); setF(null); load(); } catch (e) { alert(e.response?.data?.error || 'Error'); } };
  const resolver = async (id, estado) => { await rhResolverVacacion(id, estado); load(); };
  return (
    <Card>
      {saldo && <div style={s.saldos}>
        <Saldo l="Causadas" v={saldo.causadas} c="#7dd3fc" /><Saldo l="Disfrutadas" v={saldo.disfrutadas} c="#94a3b8" />
        <Saldo l="Pendientes" v={saldo.pendientes} c="#fbbf24" /><Saldo l="Saldo disponible" v={saldo.saldo} c="#10b981" />
      </div>}
      <BtnNuevo onClick={() => setF({ fecha_inicio: '', fecha_fin: '', motivo: '' })} label="+ Solicitar vacaciones" />
      {f && <FormBox onCancel={() => setF(null)} onSave={guardar}>
        <Inp label="Desde" type="date" value={f.fecha_inicio} onChange={v => setF({ ...f, fecha_inicio: v })} />
        <Inp label="Hasta" type="date" value={f.fecha_fin} onChange={v => setF({ ...f, fecha_fin: v })} />
        <div style={{ alignSelf: 'flex-end', color: '#94a3b8', fontSize: 12 }}>{dias(f.fecha_inicio, f.fecha_fin)} días</div>
        <Inp label="Motivo" value={f.motivo} onChange={v => setF({ ...f, motivo: v })} />
      </FormBox>}
      <Tabla cols={['Desde', 'Hasta', 'Días', 'Motivo', 'Estado', '']} rows={rows} render={v => [
        fdate(v.fecha_inicio), fdate(v.fecha_fin), v.dias, v.motivo || '—', <Badge e={v.estado} />,
        <Acciones estado={v.estado} onOk={() => resolver(v.id, 'aprobado')} onNo={() => resolver(v.id, 'rechazado')} onDel={async () => { if (window.confirm('¿Eliminar?')) { await rhBorrarVacacion(v.id); load(); } }} />]} />
    </Card>
  );
}

// ── Ausencias ──
function Ausencias({ empId }) {
  const [rows, setRows] = useState([]); const [f, setF] = useState(null); const [file, setFile] = useState(null);
  const load = () => rhAusencias(empId).then(r => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [empId]);
  const guardar = async () => {
    try {
      const fd = new FormData();
      Object.entries({ ...f, dias: dias(f.fecha_inicio, f.fecha_fin) }).forEach(([k, v]) => fd.append(k, v ?? ''));
      if (file) fd.append('soporte', file);
      await rhCrearAusencia(empId, fd); setF(null); setFile(null); load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
  };
  const resolver = async (id, estado) => { await rhResolverAusencia(id, estado); load(); };
  return (
    <Card>
      <BtnNuevo onClick={() => setF({ tipo: 'incapacidad', fecha_inicio: '', fecha_fin: '', descripcion: '' })} label="+ Registrar ausencia" />
      {f && <FormBox onCancel={() => { setF(null); setFile(null); }} onSave={guardar}>
        <Sel label="Tipo" value={f.tipo} onChange={v => setF({ ...f, tipo: v })} opts={['incapacidad', 'incapacidad laboral', 'licencia maternidad', 'licencia paternidad', 'permiso', 'licencia', 'calamidad', 'ausencia injustificada']} />
        <Inp label="Desde" type="date" value={f.fecha_inicio} onChange={v => setF({ ...f, fecha_inicio: v })} />
        <Inp label="Hasta" type="date" value={f.fecha_fin} onChange={v => setF({ ...f, fecha_fin: v })} />
        <Inp label="Descripción" value={f.descripcion} onChange={v => setF({ ...f, descripcion: v })} />
        <div style={{ display: 'flex', flexDirection: 'column' }}><label style={s.lbl}>Soporte</label><input type="file" onChange={e => setFile(e.target.files[0])} style={{ color: '#cbd5e1', fontSize: 12 }} /></div>
      </FormBox>}
      <Tabla cols={['Tipo', 'Desde', 'Hasta', 'Días', 'Descripción', 'Soporte', 'Estado', '']} rows={rows} render={a => [
        a.tipo, fdate(a.fecha_inicio), fdate(a.fecha_fin), a.dias, a.descripcion || '—',
        a.soporte_url ? <a href={`${API_BASE}${a.soporte_url}`} target="_blank" rel="noreferrer" style={{ color: '#93c5fd' }}>ver</a> : '—',
        <Badge e={a.estado} />,
        <Acciones estado={a.estado} onOk={() => resolver(a.id, 'aprobado')} onNo={() => resolver(a.id, 'rechazado')} onDel={async () => { if (window.confirm('¿Eliminar?')) { await rhBorrarAusencia(a.id); load(); } }} />]} />
    </Card>
  );
}

// ── Documentos ──
function Documentos({ empId }) {
  const [rows, setRows] = useState([]); const [tipo, setTipo] = useState('Hoja de vida'); const [file, setFile] = useState(null); const [busy, setBusy] = useState(false);
  const load = () => rhDocumentos(empId).then(r => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [empId]);
  const subir = async () => {
    if (!file) return; setBusy(true);
    try { const fd = new FormData(); fd.append('tipo', tipo); fd.append('archivo', file); await rhSubirDocumento(empId, fd); setFile(null); load(); }
    catch (e) { alert(e.response?.data?.error || 'Error'); } finally { setBusy(false); }
  };
  return (
    <Card>
      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', marginBottom: 12, flexWrap: 'wrap' }}>
        <Sel label="Tipo" value={tipo} onChange={setTipo} opts={['Hoja de vida', 'Contrato firmado', 'Cédula', 'Certificado', 'Examen médico', 'Otro']} />
        <div style={{ display: 'flex', flexDirection: 'column' }}><label style={s.lbl}>Archivo</label><input type="file" onChange={e => setFile(e.target.files[0])} style={{ color: '#cbd5e1', fontSize: 12 }} /></div>
        <button style={s.btnPri} disabled={busy || !file} onClick={subir}>{busy ? 'Subiendo…' : 'Subir'}</button>
      </div>
      <Tabla cols={['Tipo', 'Nombre', 'Subido', '']} rows={rows} render={d => [
        d.tipo, <a href={`${API_BASE}${d.archivo_url}`} target="_blank" rel="noreferrer" style={{ color: '#93c5fd' }}>{d.nombre}</a>, fdate(d.subido_at),
        <Del onClick={async () => { if (window.confirm('¿Eliminar documento?')) { await rhBorrarDocumento(d.id); load(); } }} />]} />
    </Card>
  );
}

// ── Evaluaciones ──
function Evaluaciones({ empId }) {
  const [rows, setRows] = useState([]); const [f, setF] = useState(null);
  const load = () => rhEvaluaciones(empId).then(r => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [empId]);
  const guardar = async () => { try { await rhCrearEvaluacion(empId, f); setF(null); load(); } catch (e) { alert(e.response?.data?.error || 'Error'); } };
  const setCrit = (i, k, v) => setF(x => ({ ...x, criterios: x.criterios.map((c, j) => j === i ? { ...c, [k]: v } : c) }));
  return (
    <Card>
      <BtnNuevo onClick={() => setF({ periodo: '', evaluador: '', comentarios: '', criterios: [{ nombre: 'Puntualidad', puntaje: 3 }, { nombre: 'Calidad del trabajo', puntaje: 3 }, { nombre: 'Trabajo en equipo', puntaje: 3 }] })} label="+ Nueva evaluación" />
      {f && <FormBox onCancel={() => setF(null)} onSave={guardar} col>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <Inp label="Periodo" value={f.periodo} onChange={v => setF({ ...f, periodo: v })} />
          <Inp label="Evaluador" value={f.evaluador} onChange={v => setF({ ...f, evaluador: v })} />
        </div>
        <div style={{ marginTop: 8 }}>
          {f.criterios.map((c, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
              <input style={{ ...s.inp, flex: 1 }} value={c.nombre} onChange={e => setCrit(i, 'nombre', e.target.value)} />
              <select style={s.inp} value={c.puntaje} onChange={e => setCrit(i, 'puntaje', Number(e.target.value))}>{[1, 2, 3, 4, 5].map(n => <option key={n} value={n}>{n}</option>)}</select>
              <button style={s.delBtn} onClick={() => setF(x => ({ ...x, criterios: x.criterios.filter((_, j) => j !== i) }))}>✕</button>
            </div>
          ))}
          <button style={s.btnSec} onClick={() => setF(x => ({ ...x, criterios: [...x.criterios, { nombre: '', puntaje: 3 }] }))}>+ Criterio</button>
        </div>
        <div style={{ marginTop: 8 }}><Inp label="Comentarios" value={f.comentarios} onChange={v => setF({ ...f, comentarios: v })} wide /></div>
      </FormBox>}
      <Tabla cols={['Fecha', 'Periodo', 'Evaluador', 'Puntaje', 'Comentarios', '']} rows={rows} render={e => [
        fdate(e.fecha), e.periodo || '—', e.evaluador || '—',
        <b style={{ color: e.puntaje >= 4 ? '#10b981' : e.puntaje >= 3 ? '#fbbf24' : '#fca5a5' }}>{e.puntaje ?? '—'}/5</b>,
        e.comentarios || '—', <Del onClick={async () => { if (window.confirm('¿Eliminar?')) { await rhBorrarEvaluacion(e.id); load(); } }} />]} />
    </Card>
  );
}

// ── UI helpers ──
const Card = ({ children }) => <div style={s.card}>{children}</div>;
const BtnNuevo = ({ onClick, label }) => <button style={{ ...s.btnPri, marginBottom: 12 }} onClick={onClick}>{label}</button>;
const FormBox = ({ children, onCancel, onSave, col }) => (
  <div style={s.formBox}>
    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', flexDirection: col ? 'column' : 'row' }}>{children}</div>
    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
      <button style={s.btnSec} onClick={onCancel}>Cancelar</button><button style={s.btnPri} onClick={onSave}>Guardar</button>
    </div>
  </div>
);
const Inp = ({ label, value, onChange, type = 'text', wide }) => (
  <div style={{ display: 'flex', flexDirection: 'column', flex: wide ? '1 1 100%' : '1 1 140px' }}>
    <label style={s.lbl}>{label}</label>
    <input style={s.inp} type={type} value={value} onChange={e => onChange(e.target.value)} />
  </div>
);
const Sel = ({ label, value, onChange, opts }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <label style={s.lbl}>{label}</label>
    <select style={s.inp} value={value} onChange={e => onChange(e.target.value)}>{opts.map(o => <option key={o} value={o}>{o}</option>)}</select>
  </div>
);
const Tabla = ({ cols, rows, render }) => (
  <div style={{ overflowX: 'auto' }}>
    <table style={s.table}>
      <thead><tr>{cols.map((c, i) => <th key={i} style={s.th}>{c}</th>)}</tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={cols.length} style={{ ...s.td, textAlign: 'center', color: '#64748b', padding: 20 }}>Sin registros</td></tr>}
        {rows.map((r, i) => <tr key={r.id || i}>{render(r).map((cell, j) => <td key={j} style={s.td}>{cell}</td>)}</tr>)}
      </tbody>
    </table>
  </div>
);
const Del = ({ onClick }) => <button style={s.delBtn} onClick={onClick} title="Eliminar">✕</button>;
const Acciones = ({ estado, onOk, onNo, onDel }) => (
  <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
    {estado === 'pendiente' && <><button style={s.okBtn} onClick={onOk}>Aprobar</button><button style={s.noBtn} onClick={onNo}>Rechazar</button></>}
    <Del onClick={onDel} />
  </div>
);
const Saldo = ({ l, v, c }) => <div style={s.saldoBox}><div style={{ fontSize: 20, fontWeight: 700, color: c }}>{v}</div><div style={{ fontSize: 11, color: '#64748b' }}>{l}</div></div>;

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '2px 0 0' },
  sel: { background: '#0f172a', border: '1px solid #334155', color: '#f1f5f9', borderRadius: 8, padding: '8px 10px', fontSize: 13, minWidth: 180 },
  ficha: { background: '#0f172a', border: '1px solid #334155', borderRadius: 10, padding: '10px 14px', marginBottom: 12 },
  tabs: { display: 'flex', gap: 4, borderBottom: '1px solid #334155', marginBottom: 14, flexWrap: 'wrap' },
  tab: { background: 'transparent', border: 'none', color: '#94a3b8', padding: '9px 16px', fontSize: 13, cursor: 'pointer', borderRadius: '6px 6px 0 0' },
  tabOn: { background: '#1e3a5f', border: '1px solid #3b82f6', color: '#7dd3fc' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18 },
  formBox: { background: '#0f172a', border: '1px solid #334155', borderRadius: 10, padding: 14, marginBottom: 14 },
  lbl: { color: '#94a3b8', fontSize: 11, marginBottom: 4 },
  inp: { background: '#1e293b', border: '1px solid #334155', borderRadius: 6, padding: '7px 9px', color: '#e2e8f0', fontSize: 13 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', borderBottom: '1px solid #334155' },
  td: { padding: '9px 8px', color: '#cbd5e1', borderBottom: '1px solid #172033' },
  btnPri: { background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  btnSec: { background: '#334155', color: '#cbd5e1', border: '1px solid #475569', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  okBtn: { background: '#166534', color: '#86efac', border: '1px solid #16a34a', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' },
  noBtn: { background: '#450a0a', color: '#fca5a5', border: '1px solid #b91c1c', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' },
  delBtn: { background: 'none', border: '1px solid #7f1d1d', color: '#fca5a5', borderRadius: 6, padding: '3px 8px', fontSize: 12, cursor: 'pointer' },
  saldos: { display: 'flex', gap: 12, marginBottom: 14, flexWrap: 'wrap' },
  saldoBox: { background: '#0f172a', border: '1px solid #334155', borderRadius: 10, padding: '10px 18px', textAlign: 'center', minWidth: 110 },
};
